import React from 'react';

import { Box, Card, Icon, Table, Text } from '@betterment/samba-react';

import { GroupedFailureRow } from './GroupedFailureRow';
import { UngroupedFailureRow } from './UngroupedFailureRow';

import { FeeAttemptFailure, separateAndGroupFailures } from '../data';

interface ResolveErrorsTableProps {
  failures: FeeAttemptFailure[];
}

const ResolveErrorsTable: React.FC<ResolveErrorsTableProps> = ({ failures }) => {
  // Separate, group, and sort failures by row number
  const allFailures = separateAndGroupFailures(failures);

  return (
    <Card
      css={{
        borderStyle: 'solid',
        borderWidth: 'thin',
        borderColor: 'border',
        boxShadow: 'none',
      }}
    >
      <Card.Content css={{ p: '0' }}>
        <Table
          aria-label="resolveErrorsTable"
          css={{
            bg: 'background.surface',
            overflowX: 'visible',
            tableLayout: 'fixed',
          }}
        >
          <Table.Header>
            <Table.Row>
              <Table.ColumnHeaderCell css={{ width: '10%' }}>Row</Table.ColumnHeaderCell>
              <Table.ColumnHeaderCell css={{ width: '25%' }}>Account</Table.ColumnHeaderCell>
              <Table.ColumnHeaderCell css={{ width: '20%' }}>Fee amount</Table.ColumnHeaderCell>
              <Table.ColumnHeaderCell css={{ width: '45%' }}>
                <Box css={{ display: 'flex', alignItems: 'center', gap: 'space.100' }}>
                  <Icon name="WarningFilled" color="icon.warning" size="small" data-testid="issues-warning-icon" />
                  <Text color="text.warning" css={{ fontWeight: 'bold' }}>
                    Issue(s)
                  </Text>
                </Box>
              </Table.ColumnHeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {allFailures.map(item => {
              if (item.type === 'grouped') {
                return (
                  <GroupedFailureRow
                    key={`grouped-${item.accountKey}`}
                    accountKey={item.accountKey}
                    failures={item.failures}
                  />
                );
              }
              return <UngroupedFailureRow key={`ungrouped-${item.failure.row}`} failure={item.failure} />;
            })}
          </Table.Body>
        </Table>
      </Card.Content>
    </Card>
  );
};

export default ResolveErrorsTable;
